"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeDto = void 0;
class EmployeeDto {
    constructor(employee) {
        Object.assign(this, employee);
    }
}
exports.EmployeeDto = EmployeeDto;
